module.exports = __webpack_public_path__ + "static/media/rekvizit.2e8654ba.pdf";